module.exports = __webpack_public_path__ + "media/Audio23.f302d689.wav";